import { ResumeMainPage } from '../ResumeMainPage'
import { Typography } from '@mui/material'

export function JapanesePage() {
    return (
        <ResumeMainPage index="Natural_Language/Japanese">
            <Typography>
                <b>I am not a native Japanese speaker.</b> Inspired by Japanese animation, I
                initially taught myself basic Japanese, including the Gojūon, which enabled me to
                sing some of my favorite anime songs. I've also enjoyed watching anime and playing
                Pokémon. In recent years, I've taken a more structured approach to learning through
                Duolingo and Japanese language books. My goal is to pass the N2 exam.
            </Typography>
        </ResumeMainPage>
    )
}
